<template>
  <div>
    <print-temp />
  </div>
</template>

<script>
import printTemp from './PrintTemp.vue'
import storage from '@/utils/storagehandle'

export default {
  name: 'warehouseOutPrinttemp',
  components: {
    printTemp
  },
  destroyed () {
    storage.removeItem('taskPrintBillOutGoodList')
    storage.removeItem('taskPrintBillOutGoodsTotalPiece')
    storage.removeItem('taskPrintBillOutGoodsSku')
  }
}
</script>



// WEBPACK FOOTER //
// src/page/assignmentManage/warehouseOutPrinttemp.vue